<script setup lang="ts">
import { computed } from 'vue';

interface UiVerticalDividerProps {
  height?: 'full' | 'auto' | string;
  color?: 'default'
  thickness?: 'normal';
}

const props = withDefaults(defineProps<UiVerticalDividerProps>(), {
  height: 'full',
  color: 'default',
  thickness: 'normal',
});

const dividerClasses = computed(() => {
  let classes = 'border-l';

  // Height classes
  switch (props.height) {
    case 'full':
      classes += ' h-full';
      break;
    case 'auto':
      classes += ' h-auto';
      break;
    default:
      classes += ` ${props.height}`;
  }

  // Color classes
  switch (props.color) {
    default:
      classes += ' border-gray-300';
  }

  // Thickness classes
  switch (props.thickness) {
    default:
      break;
  }

  return classes;
});
</script>

<template>
  <div :class="dividerClasses" />
</template>
